import moment from 'moment'

// 格式化日期
export function formatDate (date, format) {
    let newDate = null
  
    if (date && moment(date).isValid()) {
      newDate = moment(date).format(format)
    }
  
    return newDate
}